export default 'ETI et grands comptes : courtage haute tension (HTA), primes CEE industrielles, conformité Décret Tertiaire 2030, reporting énergie ISO 50001. Référent dédié, Accord de confidentialité disponible, premier échange offert.';
